// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Next = require("../../../reason/next/Next.bs.js");
let React = require("react");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");

let errorMessage = "Please ignore this error.";

let throwFakeErrorToFoolNextRouter = (// Throwing an actual error class trips the Next.JS 500 Page, this string literal does not.
      () => { throw errorMessage });

function rejectionHandler(event) {
  let reason = event.reason;
  if (Stdlib_Option.getOr(reason, "").includes(errorMessage)) {
    event.preventDefault();
    return;
  }
}

function use(shouldStopNavigation, onNavigate) {
  let router = Next.useRouter();
  let currentPath = Next.Router.asPath(router);
  let match = React.useState(() => {});
  let setNextPath = match[1];
  let nextPath = match[0];
  let navigationConfirmed = React.useRef(false);
  let killRouterEvent = React.useCallback(() => {
    Next.Router.Events.emit(Next.Router.events(router), {
      NAME: "routeChangeError",
      VAL: [
        "",
        "",
        {
          shallow: false
        }
      ]
    });
    throwFakeErrorToFoolNextRouter();
  }, [router]);
  React.useEffect(() => {
    navigationConfirmed.current = false;
    let onRouteChange = url => {
      if (shouldStopNavigation && url !== currentPath && !navigationConfirmed.current) {
        setNextPath(param => url.replace(Next.Router.basePath(router), ""));
        onNavigate();
        return killRouterEvent();
      }
    };
    Next.Router.Events.on(Next.Router.events(router), {
      NAME: "routeChangeStart",
      VAL: onRouteChange
    });
    window.addEventListener("unhandledrejection", rejectionHandler);
    return () => {
      Next.Router.Events.off(Next.Router.events(router), {
        NAME: "routeChangeStart",
        VAL: onRouteChange
      });
      window.removeEventListener("unhandledrejection", rejectionHandler);
    };
  }, [
    currentPath,
    killRouterEvent,
    onNavigate,
    setNextPath,
    shouldStopNavigation
  ]);
  if (nextPath !== undefined) {
    return () => {
      navigationConfirmed.current = true;
      Next.Router.push(nextPath, undefined, undefined, router);
    };
  }
}

exports.errorMessage = errorMessage;
exports.throwFakeErrorToFoolNextRouter = throwFakeErrorToFoolNextRouter;
exports.rejectionHandler = rejectionHandler;
exports.use = use;
/* Next Not a pure module */
